import React from 'react';

/** Marks a curated-cart line whose product was removed from the shop. The line, its price and the
 *  cart's total stay as they were; this only tells staff the product can't be bought any more. */
const NoLongerAvailable = () => (
    <span
        title="Removed from the shop. This line and the cart total are unchanged; swap it for another product if needed."
        style={{
            display: 'inline-block', marginLeft: 8, padding: '1px 7px', borderRadius: 999,
            background: '#FEF2F2', color: '#B91C1C', border: '1px solid #FCA5A5',
            fontSize: 11, fontWeight: 600, verticalAlign: 'middle', whiteSpace: 'nowrap',
        }}
    >
        No longer available
    </span>
);

export default NoLongerAvailable;
